import { render } from "./BrowserHistory.vue?vue&type=template&id=33c00df1&scoped=true&ts=true"
import script from "./BrowserHistory.vue?vue&type=script&lang=ts"
export * from "./BrowserHistory.vue?vue&type=script&lang=ts"

import "./BrowserHistory.vue?vue&type=style&index=0&id=33c00df1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c00df1"]])

export default __exports__